<p-avatar
  [label]="label()"
  [image]="choseImage()"
  [style.backgroundColor]="getColor(id())"
/>
